import React from 'react';

const Panel = ( props ) => {

  // const size = 300;

  const panelStyle = {
    // width: size,
    height: 300,
    padding: 0
  }

  return (
    <div className="border border-secondary bg-black rounded" style={panelStyle}>
      { props.children }
    </div>
  );
}

export default (Panel);
